import { action, observable, autorun } from "mobx";
import { SaveStatuses } from "./save-statuses";
import { axios } from "../../../../utils/axios";
import { reaction } from "mobx";
import MetadataBase from "./metadata-base";
import { AUTOSAVE_DELAY } from '../../constants/editor';

class QuizObjectList {
    @observable _id: string | undefined = undefined;
    @observable valueType: string = "string";
    @observable slug: string = "";
    @observable name: string = "";
    @observable ordered: boolean = false;
    @observable list: Array<string> = [""];
    @observable saveTimer = 5;
    @observable status: SaveStatuses = SaveStatuses.UNCHANGED;
    @observable saveInitiated = false;
    @observable deleted: boolean = false;
    @observable quiz_object_id: string = "";

    constructor(quiz_object_id: any, _id?: any, listData?: any) {
        this.quiz_object_id = quiz_object_id;

        if (_id) {
            this._id = _id;
        }

        if (listData) {
            this.valueType = listData.valueType;
            this.slug = listData.slug;
            this.name = listData.name;
            this.list = listData.list;
            this.ordered = listData.ordered;
        }

        reaction(
            () => {
                return JSON.stringify(this);
            },
            () => {
                this.persistList();
            },
            { delay: AUTOSAVE_DELAY }
        );
    }

    @action.bound
    toggleOrdered() {
        this.ordered = !this.ordered;
    }

    setName(name: string) {
        this.name = name;
    }

    saveListItem(index: number, value: string) {
        this.list[index] = value;
    }

    remove() {
        this.deleteList();
    }

    restore() {
        this.restoreList();
    }

    async deleteList() {
        this.status = SaveStatuses.DELETING;
        axios()
            .patch(`/quiz_objects/${this.quiz_object_id}`, {
                deleteList: this
            })
            .then(() => {
                this.deleted = true;
                this.status = SaveStatuses.DELETED;
            })
            .catch((res: any) => {
                this._id = res.updated._id;
                this.status = SaveStatuses.ERROR;
            });
    }

    async restoreList() {
        this.status = SaveStatuses.RESTORING;
        axios()
            .patch(`/quiz_objects/${this.quiz_object_id}`, {
                list: this
            })
            .then((res: any) => {
                this.status = SaveStatuses.RESTORED;
                return res.data;
            })
            .catch((res: any) => {
                this._id = res.updated._id;
                this.status = SaveStatuses.ERROR;
            });
    }

    busy() {
        return (this.status == SaveStatuses.SAVING || this.status == SaveStatuses.RESTORING || this.status == SaveStatuses.DELETING );
    }

    async persistList() {
        let _this = this;
        if (this.busy() || this.deleted) return;
        this.status = SaveStatuses.SAVING;
        axios()
            .patch(`/quiz_objects/${this.quiz_object_id}`, {
                list: this
            })
            .then((res: any) => {
                return res.data;
            })
            .then((res: any) => {
                console.log(res);
                _this._id = res.updated._id;
                _this.status = SaveStatuses.SAVED;
            })
            .catch((err: any) => {
                _this.status = SaveStatuses.ERROR;
                console.log(err);
            });
    }

    addRow() {
        this.list.push("");
    }

    removeRow(index: number) {
        this.list.splice(index, 1);
    }
}

export { QuizObjectList };
